import "aos";
import "aos/dist/aos.css";
import AOS from "aos";

window.addEventListener("load", function() {
  // init scroll library
  AOS.init();
});
